import { MdxRenderer } from "@shared/ui/MdxRenderer";
import { MdxRendererTableOfContents } from "@shared/ui/MdxRendererTableOfContents";
import { Article } from "@platform/features/support/support.types";
import { videoEventBus } from "../../../video/videoEventBus";
import { useEffect } from "react";

export type Props = {
  article: Article;
  scrollContainer?: HTMLElement | null;
};

export function VideoUIMaterials({ article, scrollContainer }: Props) {
  useEffect(() => {
    videoEventBus.emitEvent("videochat:materials:opened", {});
  }, []);

  return (
    <div className="relative flex flex-col gap-8 pb-8">
      <MdxRendererTableOfContents
        content={article?.content || ""}
        className="px-0 py-8 sticky top-0 border-b border-brand-800 shadow-brand-sm"
        innerClassName="flex-nowrap px-4"
        scrollContainer={scrollContainer}
      />
      <MdxRenderer content={article?.content || ""} className="px-4" />
    </div>
  );
}

export default VideoUIMaterials;
